module.exports = __webpack_public_path__ + "static/img/币币交易-banner4.d94b4c9c.png";